module.exports = __webpack_public_path__ + "static/fonts/Fact-Expanded.b20f5ab.eot";